const common = {
  // Nav
  "nav.guides": "Trang chủ",
  "nav.clientSdk": "Tính năng",
  "nav.serverApi": "Tài liệu",
  "nav.download": "Tải xuống",
  "nav.android": "Android",
  "nav.ios": "iOS",
  "nav.pc": "Phiên bản Web",
  "nav.github": "GitHub",
  "nav.blog": "Blog",

  // Hero
  "hero.badge": "Nhắn tin mã nguồn mở",
  "hero.title1": "Build with",
  "hero.title2": "TupIM",
  "hero.desc": "TupIM là thành phần nhắn tin tức thời mã nguồn mở do các chuyên gia IM phát triển — bao gồm máy chủ IM và SDK client. Nhẹ nhàng, linh hoạt và dễ mở rộng. Triển khai riêng tư để giữ dữ liệu an toàn.",
  "hero.download": "Tải xuống",
  "hero.stat.devs": "Nhà phát triển",
  "hero.stat.msgs": "Tin nhắn/ngày",
  "hero.badge2.title": "Mã hóa đầu cuối",
  "hero.badge2.desc": "Tin nhắn của bạn luôn được bảo mật",

  // Features
  "features.label": "Tính năng cốt lõi",
  "features.title": "Mọi thứ bạn cần để giao tiếp",
  "features.subtitle": "TupIM cung cấp giải pháp nhắn tin tức thời hoàn chỉnh — tin nhắn, cuộc gọi, nhóm, tệp và nhiều hơn nữa.",

  "feat.msg.title": "Nhắn tin tức thời",
  "feat.msg.desc": "Tin nhắn văn bản, emoji, hình ảnh, giọng nói và video với độ trễ mili giây.",
  "feat.call.title": "Cuộc gọi âm thanh & video",
  "feat.call.desc": "Cuộc gọi một-một hoặc nhóm chất lượng cao, hỗ trợ chia sẻ màn hình.",
  "feat.group.title": "Nhóm chat",
  "feat.group.desc": "Tạo và quản lý nhóm hỗ trợ hàng nghìn thành viên với đầy đủ quyền quản trị.",
  "feat.file.title": "Truyền tệp",
  "feat.file.desc": "Truyền tệp, ảnh và video nhanh chóng, an toàn với hỗ trợ tiếp tục.",
  "feat.encrypt.title": "Mã hóa đầu cuối",
  "feat.encrypt.desc": "Tất cả tin nhắn được mã hóa E2E. Khóa riêng tư chỉ tồn tại trên thiết bị của bạn.",
  "feat.notify.title": "Thông báo đẩy",
  "feat.notify.desc": "Thông báo đẩy tức thì trên tất cả nền tảng — không bao giờ bỏ lỡ tin nhắn quan trọng.",
  "feat.cross.title": "Hỗ trợ PC+APP",
  "feat.cross.desc": "Một SDK bao gồm Web, Android và iOS.",
  "feat.private.title": "Triển khai riêng tư",
  "feat.private.desc": "Triển khai trên máy chủ của bạn. Bạn sở hữu dữ liệu. Bảo mật cấp doanh nghiệp.",
  "feat.selfhost.title": "Hiệu suất cao",
  "feat.selfhost.desc": "Xây dựng với Go. Một nút hỗ trợ hàng triệu kết nối đồng thời.",

  "features.sdk.title": "Hỗ trợ SDK đa nền tảng",
  "features.sdk.desc": "Dù bạn dùng công nghệ gì, TupIM đều có SDK sẵn sàng cho bạn",

  // Api hero section
  "api.hero.title1": "Build with",
  "api.hero.title2": "TupIM",
  "api.hero.desc": "TupIM là thành phần nhắn tin tức thời mã nguồn mở. Hỗ trợ triển khai riêng tư, đảm bảo an toàn dữ liệu.",
  "api.hero.btn.start": "Bắt đầu xây dựng",
  "api.hero.btn.guide": "Hướng dẫn bắt đầu",

  // Api / Deploy section
  "api.open.title": "Hoàn toàn mã nguồn mở",
  "api.open.desc": "Máy chủ TupIM và tất cả SDK được mã nguồn mở trên GitHub theo giấy phép MIT.",
  "api.open.contrib": "Người đóng góp",
  "api.open.btn": "Xem trên GitHub",
  "api.deploy.title": "Tự lưu trữ dễ dàng",
  "api.deploy.desc": "Triển khai TupIM trên máy chủ của bạn trong vài phút. Không phụ thuộc bên thứ ba.",
  "api.deploy.f1": "Triển khai một click với Docker Compose",
  "api.deploy.f2": "Hỗ trợ triển khai cụm Kubernetes",
  "api.deploy.f3": "Hệ thống giám sát và ghi nhật ký đầy đủ",
  "api.deploy.btn": "Đọc tài liệu triển khai",

  // Help
  "help.title": "Chúng tôi có thể giúp gì cho bạn?",
  "help.demo.title": "Xem Demo",
  "help.demo.desc": "Bạn có thể tải xuống ứng dụng để kiểm thử hoặc truy cập trang demo.",
  "help.demo.link": "Đi ngay →",
  "help.support.title": "Hỗ trợ",
  "help.support.desc": "Bạn có thể tìm hoặc gửi vấn đề liên quan trong kho lưu trữ mã TupIM.",
  "help.support.link": "Đi ngay →",
  "help.faq.title": "Câu hỏi thường gặp",
  "help.faq.desc": "Duyệt phần FAQ để tìm câu trả lời cho các câu hỏi phổ biến.",
  "help.faq.link": "Xem FAQ →",

  // Community
  "community.title": "Tham gia cộng đồng",
  "community.desc": "Tương tác với cộng đồng ngày càng phát triển để nhận cập nhật mới nhất và hỗ trợ sản phẩm.",
  "community.slack": "Slack →",

  // Download page
  "download.android.badge": "Ứng dụng Android",
  "download.android.title": "Tải TupIM cho Android",
  "download.android.desc": "Ứng dụng Android đầy đủ tính năng với nhắn tin, gọi thoại, video, nhóm chat, truyền tệp và nhiều hơn nữa.",
  "download.android.version": "Phiên bản mới nhất",
  "download.android.size": "Kích thước gói",
  "download.android.require": "Yêu cầu hệ thống",
  "download.android.require.val": "Android 5.0 trở lên",
  "download.android.btn": "Tải APK",
  "download.android.qr": "Quét mã QR để tải",
  "download.android.qr.desc": "Dùng camera điện thoại hoặc trình quét QR để quét",
  "download.android.tip": "Sau khi tải xuống, hãy cho phép cài đặt từ nguồn không xác định",
  "download.android.cta.title": "Bắt đầu ngay",
  "download.android.cta.desc": "Tải miễn phí — trải nghiệm nhắn tin tức thời an toàn, hiệu suất cao",

  "download.ios.badge": "Ứng dụng iOS",
  "download.ios.title": "Tải TupIM cho iOS",
  "download.ios.desc": "Ứng dụng nhắn tin cho iPhone và iPad, mang lại trải nghiệm native mượt mà với đầy đủ tính năng.",
  "download.ios.version": "Phiên bản mới nhất",
  "download.ios.size": "Kích thước gói",
  "download.ios.require": "Yêu cầu hệ thống",
  "download.ios.require.val": "iOS 13.0 trở lên",
  "download.ios.btn": "Tải trên App Store",
  "download.ios.btn2": "TestFlight Beta",
  "download.ios.qr": "Quét mã QR để tải",
  "download.ios.qr.desc": "Dùng camera iPhone để quét và vào App Store",
  "download.ios.tip": "Hỗ trợ iPhone và iPad chạy iOS 15.0 trở lên",
  "download.ios.cta.title": "Bắt đầu ngay",
  "download.ios.cta.desc": "Tải miễn phí trên App Store hoặc tham gia TestFlight để trải nghiệm tính năng mới nhất",

  // PC / Web version
  "download.pc.badge": "Phiên bản trình duyệt",
  "download.pc.title": "TupIM Phiên bản trình duyệt Web",
  "download.pc.desc": "Không cần cài đặt. Truy cập từ trình duyệt Web bất cứ lúc nào, bất cứ đâu và tận hưởng đầy đủ tính năng nhắn tin tức thời.",
  "download.pc.btn.open": "Mở ngay",
  "download.pc.tip": "Miễn phí · Không cần cài đặt. Đồng bộ với tất cả thiết bị.",
  "download.pc.features.title": "Tính năng cốt lõi",
  "download.pc.features.subtitle": "Trải nghiệm giao tiếp đầy đủ ngay trên trình duyệt",
  "download.pc.screenshots.title": "Ảnh chụp màn hình",
  "download.pc.ss.chats": "Chat",
  "download.pc.ss.call": "Gọi video",
  "download.pc.ss.group": "Nhóm chat",
  "download.pc.ss.file": "Quản lý tệp",
  "download.pc.cta.title": "Bắt đầu trên trình duyệt Web",
  "download.pc.cta.desc": "Không cần cài đặt, sử dụng ngay trên bất kỳ trình duyệt nào",
  "download.pc.cta.btn": "Mở trên trình duyệt",
  "download.pc.browser.support": "Trình duyệt được hỗ trợ",

  // Download features
  "download.feature.msg": "Nhắn tin tức thời",
  "download.feature.msg.desc": "Hỗ trợ văn bản, emoji, hình ảnh, giọng nói, video và các loại tin nhắn khác",
  "download.feature.call": "Gọi âm thanh/video",
  "download.feature.call.desc": "Gọi một-một hoặc nhóm âm thanh/video, rõ ràng và mượt mà",
  "download.feature.group": "Nhóm chat",
  "download.feature.group.desc": "Tạo và quản lý nhóm, hỗ trợ hàng nghìn thành viên",
  "download.feature.file": "Truyền tệp",
  "download.feature.file.desc": "Truyền tệp, ảnh và video nhanh chóng và an toàn",
  "download.feature.encrypt": "Mã hóa đầu cuối",
  "download.feature.encrypt.desc": "Tất cả tin nhắn được mã hóa E2E để bảo vệ quyền riêng tư",
  "download.feature.notify": "Thông báo đẩy",
  "download.feature.notify.desc": "Thông báo đẩy tức thì cho tin nhắn quan trọng, không bao giờ bỏ lỡ",
  "download.feature.shortcut": "Phím tắt",
  "download.feature.shortcut.desc": "Tăng năng suất với các phím tắt và thao tác nhanh trên desktop",

  // Download Section (homepage)
  "dl.label": "Tải xuống",
  "dl.title": "Tải xuống đa nền tảng",
  "dl.subtitle": "Có sẵn trên Android, iOS và tất cả trình duyệt chính. Tin nhắn đồng bộ liền mạch trên mọi thiết bị.",
  "dl.sync": "Tất cả phiên bản đều miễn phí. Dữ liệu đồng bộ thời gian thực trên tất cả thiết bị.",
  "dl.android.title": "Android",
  "dl.android.desc": "Ứng dụng nhắn tin đầy đủ tính năng cho điện thoại và máy tính bảng Android.",
  "dl.android.req": "Android 5.0+",
  "dl.android.btn": "Tải cho Android",
  "dl.ios.title": "iPhone & iPad",
  "dl.ios.desc": "Trải nghiệm iOS native cho iPhone và iPad. Mượt mà, nhanh và được thiết kế đẹp cho thiết bị Apple.",
  "dl.ios.req": "iOS 15.0+",
  "dl.ios.btn": "Tải cho iOS",
  "dl.pc.title": "Phiên bản trình duyệt",
  "dl.pc.desc": "Không cần cài đặt. Truy cập ngay từ trình duyệt Web.",
  "dl.pc.req": "Bất kỳ trình duyệt",
  "dl.pc.btn": "Mở trên trình duyệt",

  // Showcase
  "showcase.label": "Khám phá sâu",
  "showcase.title": "Mọi tính năng, được thiết kế cho bạn",
  "showcase.subtitle": "Từ nhắn tin tức thời đến gọi video, mỗi module đều được tinh chỉnh để mang lại trải nghiệm giao tiếp mượt mà nhất.",
  "showcase.msg.title": "Nhắn tin tức thời",
  "showcase.msg.tag": "Nhắn tin",
  "showcase.msg.desc": "Giao hàng mili giây với hỗ trợ tất cả loại tin nhắn đa phương tiện phong phú",
  "showcase.msg.p1": "Hỗ trợ 20+ loại tin nhắn: văn bản, emoji, hình ảnh, giọng nói, video, tệp và nhiều hơn",
  "showcase.msg.p2": "Xác nhận đã đọc hiển thị cho cả hai bên",
  "showcase.msg.p3": "Thu hồi tin nhắn, trả lời trích dẫn và hỗ trợ @đề cập",
  "showcase.msg.p4": "Tin nhắn offline đồng bộ tự động",
  "showcase.call.title": "Gọi âm thanh & video",
  "showcase.call.tag": "Gọi",
  "showcase.call.desc": "Cuộc gọi HD ổn định ngay cả khi mạng yếu",
  "showcase.call.p1": "Hỗ trợ gọi âm thanh/video một-một và nhiều người",
  "showcase.call.p2": "Tính năng chia sẻ màn hình tích hợp",
  "showcase.call.p3": "Tốc độ bit thích ứng giữ cuộc gọi ổn định trong mọi điều kiện mạng",
  "showcase.call.p4": "Ghi âm cuộc gọi để phát lại khi cần",
  "showcase.group.title": "Nhóm chat",
  "showcase.group.tag": "Nhóm",
  "showcase.group.desc": "Quản lý nhóm linh hoạt và mạnh mẽ hỗ trợ hàng nghìn thành viên",
  "showcase.group.p1": "Một nhóm hỗ trợ tối đa 1.000 thành viên",
  "showcase.group.p2": "Vai trò quản trị viên đa cấp với kiểm soát quyền chi tiết",
  "showcase.group.p3": "Thông báo nhóm, tệp chia sẻ và album nhóm tích hợp",
  "showcase.group.p4": "Tắt tiếng, đuổi ra và phê duyệt tham gia để kiểm duyệt nhóm đầy đủ",
  "showcase.security.title": "Mã hóa đầu cuối",
  "showcase.security.tag": "Quyền riêng tư",
  "showcase.security.desc": "Mã hóa E2E — khóa riêng tư không bao giờ rời khỏi thiết bị của bạn",
  "showcase.security.p1": "Tất cả tin nhắn được mã hóa E2E hoàn toàn — máy chủ không thể đọc",
  "showcase.security.p2": "Hỗ trợ tự xóa sau khi đọc",
  "showcase.security.p3": "Tự lưu trữ — dữ liệu của bạn trên máy chủ của bạn",
  "showcase.security.p4": "Kiểm toán bảo mật bên thứ ba thường xuyên",

  // Pricing
  "pricing.label": "Gói giá",
  "pricing.title": "Chọn gói phù hợp cho bạn",
  "pricing.subtitle": "Dù là nhà phát triển độc lập, đội nhóm đang phát triển hay doanh nghiệp lớn — TupIM có gói phù hợp.",
  "pricing.popular": "Phổ biến nhất",
  "pricing.includes": "Bao gồm",
  "pricing.note": "Tất cả gói bao gồm dùng thử miễn phí 7 ngày, không cần thẻ tín dụng.",
  "pricing.starter.name": "Starter",
  "pricing.starter.tag": "Cá nhân / Nhóm nhỏ",
  "pricing.starter.desc": "Hoàn hảo cho nhà phát triển cá nhân và ứng dụng nhỏ khám phá khả năng cốt lõi của TupIM.",
  "pricing.starter.cta": "Bắt đầu miễn phí",
  "pricing.starter.f1": "Tối đa 500 người dùng hoạt động",
  "pricing.starter.f2": "Tin nhắn văn bản, hình ảnh và giọng nói",
  "pricing.starter.f3": "Gọi âm thanh & video một-một",
  "pricing.starter.f4": "Nhóm cơ bản (tối đa 50 thành viên)",
  "pricing.starter.f5": "Hỗ trợ kỹ thuật cộng đồng",
  "pricing.starter.m1": "Gọi nhóm nhiều người",
  "pricing.starter.m2": "Triển khai riêng tư",
  "pricing.starter.m3": "Hỗ trợ kỹ thuật chuyên dụng",
  "pricing.pro.name": "Pro",
  "pricing.pro.tag": "Nhóm đang phát triển",
  "pricing.pro.desc": "Dành cho sản phẩm và nhóm phát triển nhanh. Mở khóa toàn bộ tính năng để xử lý hàng triệu người dùng.",
  "pricing.pro.cta": "Liên hệ bán hàng",
  "pricing.pro.f1": "Tối đa 10.000 người dùng hoạt động",
  "pricing.pro.f2": "Tất cả loại tin nhắn đa phương tiện",
  "pricing.pro.f3": "Gọi nhóm âm thanh & video nhiều người",
  "pricing.pro.f4": "Nhóm tối đa 1.000 thành viên",
  "pricing.pro.f5": "Chia sẻ màn hình & ghi âm cuộc gọi",
  "pricing.pro.f6": "Mã hóa E2E & tự xóa sau khi đọc",
  "pricing.pro.m1": "Triển khai riêng tư",
  "pricing.enterprise.name": "Enterprise",
  "pricing.enterprise.tag": "Doanh nghiệp lớn",
  "pricing.enterprise.desc": "Được thiết kế cho ứng dụng quy mô lớn và nhu cầu doanh nghiệp. Hoàn toàn tự lưu trữ.",
  "pricing.enterprise.cta": "Nhận báo giá",
  "pricing.enterprise.f1": "Người dùng hoạt động không giới hạn",
  "pricing.enterprise.f2": "Tất cả tính năng, không giới hạn",
  "pricing.enterprise.f3": "Triển khai riêng tư & giấy phép mã nguồn",
  "pricing.enterprise.f4": "Tính khả dụng cao của cụm Kubernetes",
  "pricing.enterprise.f5": "Đảm bảo SLA 99.99% thời gian hoạt động",
  "pricing.enterprise.f6": "Tư vấn kỹ thuật chuyên dụng",
  "pricing.enterprise.f7": "Phát triển tính năng tùy chỉnh",

  // Docs page
  "docs.title": "Tài liệu",
  "docs.group.start": "Bắt đầu",
  "docs.group.core": "Tính năng cốt lõi",
  "docs.group.dev": "Hướng dẫn nhà phát triển",
  "docs.nav.introduction": "Giới thiệu",
  "docs.nav.quickstart": "Bắt đầu nhanh",
  "docs.nav.messaging": "Nhắn tin tức thời",
  "docs.nav.calls": "Gọi âm thanh & video",
  "docs.nav.groups": "Quản lý nhóm",
  "docs.nav.encryption": "Bảo mật & mã hóa",
  "docs.nav.sdk": "Tích hợp SDK",
  "docs.nav.deployment": "Tự lưu trữ",
  "docs.nav.api": "Tham chiếu API",
  "docs.toc": "Mục lục",
  "docs.copied": "Đã sao chép",
  "docs.copy": "Sao chép",
  "docs.install": "Cài đặt",
  "docs.init": "Khởi tạo",

  // Docs - Server group
  "docs.group.server": "Máy chủ",
  "docs.nav.sfu": "Tính toán băng thông SFU",
  "docs.sfu.title": "Cách tính băng thông hội nghị video SFU",
  "docs.sfu.intro": "Trong kiến trúc SFU, mỗi người tham gia tải luồng của mình lên máy chủ SFU, máy chủ chọn lọc và chuyển tiếp các luồng từ các người khác. Tài liệu này hướng dẫn cách ước tính yêu cầu băng thông cho hội nghị video SFU.",
  "docs.sfu.arch.title": "Tổng quan kiến trúc SFU",
  "docs.sfu.arch.desc": "Khác MCU, SFU không trộn luồng. Mỗi người tham gia duy trì N-1 luồng xuống và 1 luồng lên. Điều này giúp SFU mở rộng tốt cho cuộc gọi nhóm lớn.",
  "docs.sfu.formula.title": "Công thức tính băng thông",
  "docs.sfu.formula.uplink": "Luồng lên (mỗi người): tải 1 luồng video",
  "docs.sfu.formula.downlink": "Luồng xuống (mỗi người): tải (N-1) luồng video",
  "docs.sfu.formula.total": "Tổng băng thông máy chủ = N × bitrate lên + N × (N-1) × bitrate xuống",
  "docs.sfu.params.title": "Thông số bitrate tham khảo",
  "docs.sfu.params.hd": "HD (720p): ~1.5 Mbps lên / ~1.2 Mbps xuống",
  "docs.sfu.params.sd": "SD (480p): ~0.8 Mbps lên / ~0.6 Mbps xuống",
  "docs.sfu.params.ld": "Thấp (240p): ~0.3 Mbps lên / ~0.25 Mbps xuống",
  "docs.sfu.example.title": "Ví dụ tính toán",
  "docs.sfu.example.desc": "Các ví dụ sau giả sử chất lượng HD (720p) với 1.5 Mbps lên và 1.2 Mbps xuống mỗi người.",
  "docs.sfu.note.title": "Lưu ý quan trọng",
  "docs.sfu.note.1": "Thêm ~20% overhead cho header giao thức, truyền lại và lưu lượng RTCP.",
  "docs.sfu.note.2": "Bật simulcast để SFU tự động chọn chất lượng luồng phù hợp cho từng người nhận.",
  "docs.sfu.note.3": "Luồng âm thanh thường cộng thêm 50–100 kbps mỗi người và cần tính riêng.",
  "docs.sfu.note.4": "Luồng chia sẻ màn hình có thể cần thêm 2–4 Mbps băng thông lên.",

  // Footer
  "footer.tagline": "TupIM\u00a0Bảo vệ quyền riêng tư toàn diện với chat riêng tư, nhóm chat, tin nhắn bảo mật & nhiều hơn nữa",
  "footer.col.product": "Sản phẩm",
  "footer.col.developer": "Nhà phát triển",
  "footer.col.company": "Công ty",
  "footer.link.features": "Tính năng",
  "footer.link.download": "Tải xuống",
  "footer.link.changelog": "Nhật ký thay đổi",
  "footer.link.docs": "Tài liệu",
  "footer.link.api": "Tham chiếu API",
  "footer.link.github": "GitHub",
  "footer.link.about": "Về chúng tôi",
  "footer.link.blog": "Blog",
  "footer.link.contact": "Liên hệ",
  "footer.copyright": "© 2024 TupIM. All rights reserved.",
  "footer.lang.zh": "繁體中文",
  "footer.lang.en": "English",

  // About page
  "about.badge": "Về chúng tôi",
  "about.hero.title": "Xây dựng hạ tầng nhắn tin mã nguồn mở thế hệ tiếp theo",
  "about.hero.desc": "TupIM được sáng lập bởi các kỹ sư có nhiều năm kinh nghiệm IM sâu sắc, cam kết giúp mọi nhà phát triển có thể xây dựng ứng dụng nhắn tin tức thì cấp doanh nghiệp với chi phí tối thiểu.",
  "about.hero.cta1": "Liên hệ chúng tôi",
  "about.hero.cta2": "Xem trên GitHub",
  "about.stat.devs": "Nhà phát triển toàn cầu",
  "about.stat.msgs": "Tin nhắn / Ngày",
  "about.stat.stars": "GitHub Stars",
  "about.stat.countries": "Quốc gia",
  "about.mission.label": "Sứ mệnh & Tầm nhìn",
  "about.mission.title": "Mọi ứng dụng đều xứng đáng có nhắn tin mạnh mẽ",
  "about.mission.p1": "Công nghệ IM đã lâu nay bị chi phối bởi các tập đoàn lớn. TupIM ra đời để phá vỡ vòng lặp này.",
  "about.mission.p2": "Chúng tôi cung cấp giải pháp IM mã nguồn mở hoàn chỉnh — server, Web SDK, iOS SDK và Android SDK.",
  "about.mission.p3": "Tầm nhìn của chúng tôi: trở thành cơ sở hạ tầng nhắn tin mã nguồn mở đáng tin cậy nhất thế giới.",
  "about.values.label": "Giá trị cốt lõi",
  "about.values.title": "Những điều chúng tôi tin tưởng",
  "about.values.subtitle": "Những giá trị này dẫn dắt mọi quyết định kỹ thuật và hướng phát triển sản phẩm.",
  "about.value.opensource.title": "Mở & Minh bạch",
  "about.value.opensource.desc": "Tất cả mã nguồn được mở hoàn toàn trên GitHub theo giấy phép MIT.",
  "about.value.privacy.title": "Quyền riêng tư là trước",
  "about.value.privacy.desc": "Mã hóa đầu cuối là tiêu chuẩn, không phải tùy chọn. Triển khai riêng tư giữ dữ liệu khỏi tay bên thứ ba.",
  "about.value.performance.title": "Hiệu suất cực cao",
  "about.value.performance.desc": "Máy chủ hiệu suất cao dựa trên Go xử lý hàng triệu kết nối đồng thời trên một nút.",
  "about.value.community.title": "Do cộng đồng dẫn dắt",
  "about.value.community.desc": "Hướng sản phẩm được quyết định bởi cộng đồng.",
  "about.value.developer.title": "Trải nghiệm nhà phát triển",
  "about.value.developer.desc": "Tài liệu phong phú, demo toàn diện và API SDK sạch sẽ giúp tích hợp dễ nhất có thể.",
  "about.value.enterprise.title": "Sẵn sàng cho doanh nghiệp",
  "about.value.enterprise.desc": "Kubernetes cluster, HA đa vùng, giám sát và cảnh báo đầy đủ cho môi trường sản xuất.",
  "about.timeline.label": "Mốc quan trọng",
  "about.timeline.title": "Mọi bước chúng tôi đã đi",
  "about.timeline.2020q1.date": "Q1 2020",
  "about.timeline.2020q1.title": "Khởi động dự án",
  "about.timeline.2020q1.desc": "Nhóm cốt lõi được thành lập, bắt đầu nghiên cứu và thiết kế kiến trúc máy chủ IM hiệu suất cao dựa trên Go.",
  "about.timeline.2020q3.date": "Q3 2020",
  "about.timeline.2020q3.title": "Phát hành mã nguồn mở đầu tiên",
  "about.timeline.2020q3.desc": "OpenIM Server v1.0 được đăng trên GitHub, nhận 500+ sao trong tuần đầu tiên.",
  "about.timeline.2021q2.date": "Q2 2021",
  "about.timeline.2021q2.title": "SDK phủ sóng đầy đủ nền tảng",
  "about.timeline.2021q2.desc": "iOS, Android và Web SDK ra mắt đồng thời.",
  "about.timeline.2022q1.date": "Q1 2022",
  "about.timeline.2022q1.title": "10.000 GitHub Stars",
  "about.timeline.2022q1.desc": "Vượt 10K sao trên GitHub.",
  "about.timeline.2022q4.date": "Q4 2022",
  "about.timeline.2022q4.title": "Ra mắt phiên bản Enterprise",
  "about.timeline.2022q4.desc": "Ra mắt gói doanh nghiệp với triển khai riêng tư, hỗ trợ chuyên dụng và đảm bảo SLA.",
  "about.timeline.2023q2.date": "Q2 2023",
  "about.timeline.2023q2.title": "Module âm thanh & video trực tiếp",
  "about.timeline.2023q2.desc": "Module gọi HD dựa trên WebRTC chính thức tích hợp.",
  "about.timeline.2024q1.date": "Q1 2024",
  "about.timeline.2024q1.title": "50.000 nhà phát triển toàn cầu",
  "about.timeline.2024q1.desc": "Hơn 50K nhà phát triển sử dụng TupIM trên toàn thế giới.",
  "about.timeline.2024q4.date": "Q4 2024",
  "about.timeline.2024q4.title": "Nâng cấp thương hiệu TupIM",
  "about.timeline.2024q4.desc": "Nâng cấp thương hiệu toàn diện lên TupIM, website và hệ thống tài liệu mới.",
  "about.team.label": "Nhóm của chúng tôi",
  "about.team.title": "Con người phía sau TupIM",
  "about.team.subtitle": "Nhóm kỹ sư yêu thích mã nguồn mở và niêm đam mê với công nghệ IM.",
  "about.team.ceo.name": "Alex Chen",
  "about.team.ceo.role": "CEO & Co-Founder",
  "about.team.ceo.bio": "Kiến trúc sư IM tại công ty công nghệ hàng đầu, 10+ năm kinh nghiệm.",
  "about.team.cto.name": "Kevin Wang",
  "about.team.cto.role": "CTO & Co-Founder",
  "about.team.cto.bio": "Người đóng góp cốt lõi Go và kiến trúc sư trưởng của OpenIM Server.",
  "about.team.lead.name": "Sophie Lin",
  "about.team.lead.role": "Lead Engineer",
  "about.team.lead.bio": "Kỹ sư full-stack phụ trách Web SDK và kiến trúc frontend.",
  "about.team.sdk.name": "James Zhang",
  "about.team.sdk.role": "Mobile SDK Lead",
  "about.team.sdk.bio": "Chuyên gia iOS & Android khép kín, dẫn dắt thiết kế mobile SDK.",
  "about.team.infra.name": "David Liu",
  "about.team.infra.role": "Infrastructure Lead",
  "about.team.infra.bio": "Chuyên gia Kubernetes phụ trách giải pháp triển khai TupIM.",
  "about.team.design.name": "Emma Wu",
  "about.team.design.role": "Product Design Lead",
  "about.team.design.bio": "Chuyên gia UX tập trung vào công cụ dành cho nhà phát triển.",

  // Contact page
  "contact.badge": "Liên hệ",
  "contact.hero.title": "Có câu hỏi? Chúng tôi ở đây.",
  "contact.hero.desc": "Dù là vấn đề kỹ thuật, yêu cầu kinh doanh hay yêu cầu truyền thông — chọn kênh phù hợp nhất và chúng tôi sẽ phản hồi sớm nhất có thể.",
  "contact.channel.support.title": "Hỗ trợ kỹ thuật",
  "contact.channel.support.desc": "Gặp lỗi, vấn đề SDK hoặc câu hỏi triển khai? Mở issue trên GitHub hoặc tham gia Slack.",
  "contact.channel.support.link1": "Gửi GitHub Issue",
  "contact.channel.support.link2": "Tham gia cộng đồng Slack",
  "contact.channel.business.title": "Yêu cầu kinh doanh",
  "contact.channel.business.desc": "Quan tâm đến gói doanh nghiệp, liên kết thương mại hoặc phát triển tùy chỉnh?",
  "contact.channel.business.link1": "Gửi email kinh doanh",
  "contact.channel.business.link2": "Tư vấn WeChat",
  "contact.channel.media.title": "Truyền thông & PR",
  "contact.channel.media.desc": "Phỏng vấn báo chí, đánh giá sản phẩm hoặc hoạt động hợp tác?",
  "contact.channel.media.link1": "Email liên hệ truyền thông",
  "contact.channel.media.link2": "Theo dõi trên Twitter",
  "contact.channel.community.title": "Cộng đồng mã nguồn mở",
  "contact.channel.community.desc": "Tham gia cộng đồng mã nguồn mở của chúng tôi, kết nối với các nhà phát triển toàn cầu.",
  "contact.channel.community.link1": "Tham gia Slack",
  "contact.channel.community.link2": "Theo dõi trên GitHub",
  "contact.response.note": "Thời gian phản hồi thông thường: Vấn đề kỹ thuật trong 24 giờ · Yêu cầu kinh doanh 1-2 ngày làm việc · Yêu cầu truyền thông 2-3 ngày làm việc",
  "contact.faq.label": "Câu hỏi thường gặp",
  "contact.faq.title": "Những điều bạn có thể muốn biết",
  "contact.faq.f1.q": "TupIM có hoàn toàn miễn phí không?",
  "contact.faq.f1.a": "Có — máy chủ và tất cả SDK khách hàng đều hoàn toàn mã nguồn mở và miễn phí theo giấy phép MIT.",
  "contact.faq.f2.q": "Làm thế nào để bắt đầu nhanh chóng?",
  "contact.faq.f2.a": "Kiểm tra tài liệu Quick Start. Triển khai máy chủ trong 5 phút với Docker Compose.",
  "contact.faq.f3.q": "Bảo mật dữ liệu được đảm bảo như thế nào?",
  "contact.faq.f3.a": "TupIM hỗ trợ triển khai riêng tư — tất cả dữ liệu nằm trên máy chủ của bạn. Tất cả tin nhắn sử dụng mã hóa đầu cuối.",
  "contact.faq.f4.q": "Hỗ trợ quy mô đồng thời nào?",
  "contact.faq.f4.a": "Kiến trúc dựa trên Go của TupIM Server xử lý 1 triệu+ kết nối đồng thời trên một nút.",
  "contact.faq.f5.q": "Làm thế nào để có giấy phép doanh nghiệp?",
  "contact.faq.f5.a": "Liên hệ đội ngũ bán hàng qua email kinh doanh hoặc WeChat, mô tả quy mô và yêu cầu của bạn.",

  "nav.about": "Về chúng tôi",
  "nav.contact": "Liên hệ",

  // Page title
  "page.title": "TupIM — Bảo vệ quyền riêng tư toàn diện với chat riêng tư | nhóm chat | tin nhắn bảo mật & nhiều hơn",
};

export default common;